module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imgns",
    attrs: {
      "id": "pg8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "690",
      "src": "images/pg8.jpg",
      "width": "387"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "capns"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("One traveled with a different concept of time, in scenery that can be reconstructed only in fragments; the rhythm was that of the horse, the environment that of a Europe with less than one tenth of its present population. Above: Horsemen from the")]), _vm._v(" History of the True Cross "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("by Piero della Francesea in San Francesco, Arezzo, and a landscape from the")]), _vm._v(" Chronica mundi "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("by Hartmann Schedel (1493).")])]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "pn",
    attrs: {
      "id": "pt1"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Over mountains to inns")])]), _vm._v(" "), _c('p', {
    staticClass: "pt"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Traveling in the Europe of five hundred years ago")])]), _vm._v(" "), _c('p', {
    staticClass: "img",
    attrs: {
      "id": "pg9"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "298",
      "src": "images/pg9.jpg",
      "width": "200"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726f9926","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 72
// module chunks = 0